module.exports = __webpack_public_path__ + "static/ha4-99671a289fe5185ea8f3dff1681506fd.jpg";